import React from 'react';

import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Avatar from '@mui/material/Avatar';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { useParams } from 'react-router-dom';
import ResetPasswordForm from './component';
import { Box } from '@mui/material';

const styles = {
  paper: (theme) => ({
    marginTop: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  }),
  avatar: (theme) => ({
    backgroundColor: theme.palette.secondary.main,
  }),
};

const ResetPassword = () => {
  const { resetToken } = useParams();
  const theme = useTheme();

  return (
    <Container component="main" maxWidth="sm">
      <div style={styles.paper(theme)}>
        <Avatar sx={styles.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Grid container sx={{ justifyContent: 'center' }}>
          <Grid item>
            <Box py={1}>
              <Typography component="h1" variant="h5">
                Set a New Password
              </Typography>
              <Typography component="p">Please create a new password to access your account.</Typography>
            </Box>
          </Grid>
        </Grid>
        <Box pt={3} width={'80%'}>
          <ResetPasswordForm resetToken={resetToken} />
        </Box>
      </div>
    </Container>
  );
};

export default ResetPassword;
